// https://lp-api.holdstation.com/aigentfi
import { request } from "@/utils/request";
import useSWR from "swr";

interface DataAiAgent {
  agents_deployed: number;
  fees: string;
  total_volume: string;
  transactions: number;
  users: number;
}

interface ResponseAiAgent {
  data?: DataAiAgent;
}

async function fetchAIAgentFi(url: string) {
  const response = await request(url);
  const data = await response.json();
  return data as ResponseAiAgent;
}

export function useAIAgent() {
  const data = useSWR("/stats/aigentfi", fetchAIAgentFi, {
    refreshInterval: 15_000,
    errorRetryInterval: 10_000,
  });

  return data;
}
